import { ChatSocket } from '../../hooks/use-socket';
import { BackendPayload } from '../backend/payloads';
import { ChatPayload } from './payload';
import { getQuery } from '../../lib/query';
import { current } from '../../stores/backend';
import { openModal } from '../../stores/backend/meta';
import {
    ChatEvent,
    FreeplayEvent,
    FreeplayEventType,
    FreeplayRestriction,
} from '../../types/bingo-events/in/chat/event';

const FREEPLAY_EVENT_TYPES: unknown[] = [
    'grant',
    'adjust',
    'revoke',
] satisfies FreeplayEventType[];

const isFreeplayEvent = (response: ChatEvent): response is FreeplayEvent =>
    response.type === 'FREEPLAY' &&
    typeof response.body === 'object' &&
    response.body !== null &&
    FREEPLAY_EVENT_TYPES.includes((response.body as { type?: unknown }).type);

const matchesRestriction = (
    restriction: FreeplayRestriction | null | undefined
) => {
    if (!restriction) return true;

    const { ROOMID } = getQuery();
    const currentRoomId = Number(ROOMID);
    const currentCurrency = current.game_currency.value.toUpperCase();

    const roomMatches =
        restriction.roomId === undefined ||
        restriction.roomId.includes(currentRoomId);
    const currencyMatches =
        restriction.currency === undefined ||
        restriction.currency.some(
            (currency) => currency.toUpperCase() === currentCurrency
        );

    return roomMatches && currencyMatches;
};

export const onEvent = (
    socket: ChatSocket,
    _payload: ChatPayload,
    getBackendPayload: () => BackendPayload | undefined
) => {
    const callback = (response: ChatEvent) => {
        if (!isFreeplayEvent(response)) return;
        if (!matchesRestriction(response.body.restriction)) return;

        if (response.body.type !== 'revoke') {
            openModal({ key: 'fpeToken' });
        }

        getBackendPayload()?.getAccountStatus();
    };

    socket.on('event:parlay', callback);

    return () => {
        socket.off('event:parlay', callback);
    };
};
